/**
 * Sérialisation .vcf côté client : convertit les contacts choisis via le Contact
 * Picker natif (Android) en vCard 3.0, pour les faire passer par le MÊME chemin
 * d'import serveur que l'upload .vcf (un seul parseur/dédup, §5). Module pur (sans
 * dépendance au runtime app) -> testable isolément.
 */

export type ContactPicke = { name?: string[]; tel?: string[]; email?: string[] };

function echapperVcf(s: string): string {
  return s.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
}

export function contactsVersVcf(contacts: ContactPicke[]): string {
  return contacts
    .map((c) => {
      const nom = (c.name?.[0] ?? '').trim();
      if (!nom) return '';
      const lignes = ['BEGIN:VCARD', 'VERSION:3.0', `FN:${echapperVcf(nom)}`];
      for (const e of c.email ?? []) if (e?.trim()) lignes.push(`EMAIL:${echapperVcf(e.trim())}`);
      for (const t of c.tel ?? [])
        if (t?.trim()) lignes.push(`TEL;TYPE=CELL:${echapperVcf(t.trim())}`);
      lignes.push('END:VCARD');
      return lignes.join('\n');
    })
    .filter(Boolean)
    .join('\n');
}
